import React, { Fragment } from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, ButtonToolbar } from 'reactstrap';
import ItinerarySchedulingButton from './ItinerarySchedulingButton';
import ItineraryEditButton from './ItineraryEditButton';
import PrintDropdownButton from '../PrintDropdownButton';
import PrintExpenseButton from '../PrintExpenseButton';
import PrintFuelVoucherButton from '../PrintFuelVoucherButton';
import ItineraryDeleteButton from './ItineraryDeleteButton';
import ExtraordinaryMovementEditButton from '../../extraordinary-movement/ExtraordinaryMovementEditButton';
import ItinerarySendGrtButton from './ItinerarySendGrtButton';
import ItinerarySendGrrButton from './ItinerarySendGrrButton';
import DeleteTripButton from './DeleteTripButton';
import { postVerifyCustomersInItinerary } from '../../../../../actions';

const ItineraryToolbar = ({
  itineraryId,
  scheduled,
  drivers,
  type,
  isForMine,
  dispatchPostVerifyCustomersInItinerary,
}) => {
  let toolbar = null;
  let rescueItineraryButton = null;

  if (isForMine)
    return (
      <ButtonToolbar className="pull-right">
        <div>
          <PrintDropdownButton isForMine={isForMine} />{' '}
          <Button
            onClick={() =>
              dispatchPostVerifyCustomersInItinerary({ itineraryId })
            }
            color="info"
          >
            Verificar
          </Button>
        </div>
      </ButtonToolbar>
    );

  if (!scheduled) {
    toolbar = <ItinerarySchedulingButton itineraryId={itineraryId} />;
  } else {
    rescueItineraryButton =
      type.toLowerCase() === 'regular' ? (
        <ExtraordinaryMovementEditButton itineraryId={itineraryId} />
      ) : null;

    toolbar = (
      <Fragment>
        <PrintDropdownButton /> <PrintExpenseButton drivers={drivers} />{' '}
        <PrintFuelVoucherButton />{' '}
        <DeleteTripButton itineraryId={itineraryId} />{' '}
        <ItinerarySendGrtButton itineraryId={itineraryId} />{' '}
        <ItinerarySendGrrButton itineraryId={itineraryId} />
      </Fragment>
    );
  }

  return (
    <ButtonToolbar className="pull-right">
      <div>
        {rescueItineraryButton} {toolbar}{' '}
        <ItineraryEditButton itineraryId={itineraryId} />{' '}
        {<ItineraryDeleteButton itineraryId={itineraryId} />}
      </div>
    </ButtonToolbar>
  );
};

ItineraryToolbar.propTypes = {
  itineraryId: PropTypes.number.isRequired,
  scheduled: PropTypes.bool.isRequired,
  drivers: PropTypes.instanceOf(Immutable.Set).isRequired,
  type: PropTypes.string.isRequired,
  isForMine: PropTypes.bool,
  dispatchPostVerifyCustomersInItinerary: PropTypes.func.isRequired,
};

ItineraryToolbar.defaultProps = {
  isForMine: false,
};

const mapDispatchToProps = {
  dispatchPostVerifyCustomersInItinerary: postVerifyCustomersInItinerary,
};

export default connect(null, mapDispatchToProps)(ItineraryToolbar);
